// Module
var code = `<div class="videoWidgetPanelSideBar" on-mousedown="@this.onMouseDown(event)">
    {{#if !loaded || !visibleCardsNum}}
        {{>noData}}
    {{/if}}

    <div class="videoWidgetPanelSideBar-item-container">
        {{#each externalLinks: i}}
            {{#if externalLinks[i].config.videoTitle}}
                <videoWidgetItemSideBar externalLink="{{externalLinks[i]}}" />
            {{/if}}
        {{/each}}
    </div>
</div>`;
// Exports
export default code;